import { useExperienceModuleContext } from '../context';
import { ExperienceEntity, ExperienceEntityTree } from '../types';

const recursiveGetChildren = (experienceEntityTree: ExperienceEntityTree): ExperienceEntity[] => {
  return experienceEntityTree.children.flatMap((child: ExperienceEntityTree) => [
    child.experienceEntity,
    ...recursiveGetChildren(child),
  ]);
};

export const useExperienceEntityChildren = (): ExperienceEntity[] => {
  const { experienceEntityTree } = useExperienceModuleContext();
  return recursiveGetChildren(experienceEntityTree);
};
